import { add, subDays } from 'date-fns';
//
import _mock from '../_mock';
import { randomInArray, randomNumberRange } from '../utils';

// ----------------------------------------------------------------------

export const _complaints = [...Array(1)].map((_, index) => ({
  id: `cp52342`,
  invoiceNumber: `CP52342`,
  orderId: randomInArray(['OD67821', 'OD52342', 'OD27632']),
  taxes: 5,
  discount: 10,
  sent: randomNumberRange(1, 10),
  subTotalPrice: _mock.number.price(index + 1),
  totalPrice: _mock.number.price(index + 1),
  createDate: subDays(new Date(), index),
  dueDate: add(new Date(), { days: index + 15, hours: index }),
  status: randomInArray(['pending', 'in-progress', 'completed']),
  complaintFrom: {
    id: _mock.id(index),
    name: _mock.name.fullName(index),
    address: _mock.address.fullAddress(index),
    company: _mock.company(index),
    email: _mock.email(index),
    phone: _mock.phoneNumber(index),
  },
  complaintTo: {
    id: _mock.id(index + 1),
    // name: _mock.name.fullName(index + 1),
    name: randomInArray(['Jack n Jill', 'Bar Tap', 'Hard Rock Cafe']),
    address: _mock.address.fullAddress(index + 1),
    company: _mock.company(index + 1),
    email: _mock.email(index + 1),
    phone: _mock.phoneNumber(index + 1),
  },
  items: [...Array(2)].map((__, itemIndex) => ({
    id: _mock.id(itemIndex),
    avatarUrl: _mock.image.avatar(itemIndex),
    title: randomInArray(['Wiskey', 'Wine', 'Cocktail']),
    description: randomInArray(['Add-On: Pepsi, Half Ice', 'Add-On: Fanta, Full Ice', 'Add-On: Coke, Half Ice']),
    quantity: 1,
    price: _mock.number.price(itemIndex),
    total: _mock.number.price(itemIndex),
    service: randomInArray([
      'full stack development',
      'backend development',
      'ui design',
      'ui/ux design',
      'front end development',
    ]),
  })),
}));

export const _complaintAddressFrom = [...Array(5)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.name.fullName(index),
  address: _mock.address.fullAddress(index),
  company: _mock.company(index),
  email: _mock.email(index),
  phone: _mock.phoneNumber(index),
}));

export const _complaintAddressTo = [...Array(16)].map((_, index) => ({
  id: _mock.id(index + 1),
  name: _mock.name.fullName(index + 1),
  address: _mock.address.fullAddress(index + 1),
  company: _mock.company(index + 1),
  email: _mock.email(index + 1),
  phone: _mock.phoneNumber(index + 1),
}));
